/**
 * Small "Google Ads" badge shown on a location card/table row when that
 * location is on the direct Google Ads conversion flow
 * (`ghl_google_ads_settings.conversion_delivery_method = 'google_ads'`).
 *
 * Render it conditionally — the caller decides presence from
 * `useQualifierGoogleAdsFlowMap()`; the badge itself is presence = "on flow".
 */

import { Megaphone } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export function GoogleAdsFlowBadge() {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            className="border-transparent bg-blue-100 text-blue-800 hover:bg-blue-100 gap-1 px-1.5 py-0 text-[10px] font-semibold"
            aria-label="On Google Ads flow"
          >
            <Megaphone className="h-3 w-3" />
            Google Ads
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          Direct Google Ads conversion upload enabled for this location
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
